import { DURATION_STEP } from "../config";

// The web client's runtime representation of an item: `lock` is minutes
// since midnight (see getInitialItems in state/days.ts and the time
// arithmetic in components/Main/Items.ts).
export type Item = {
    id: number;
    lock: number | null;
    duration: number;
    title: string;
};

// The wire/storage representation shared with the server: `lock` is a
// datetime (server/api.ts parses incoming ISO strings into Dates, and the
// mobile client speaks the same format).
export type ItemEntity = {
    id: number;
    lock: Date | null;
    // Canonical wall-clock value. `lock` remains during the legacy sync
    // compatibility window for clients that still exchange absolute instants.
    lockMinutes?: number | null;
    duration: number;
    title: string;
};

// a day in this state is dropped when the user navigates away (see
// daysReducer's UI_DAY_CHANGE case) and never needs to reach the server;
// mobile has the same notion (ItemList.isEmpty in mobile/lib/model.dart)
export const isDayPrunable = (
    items: Array<Item> | undefined | null,
): boolean =>
    items == null ||
    items.length === 0 ||
    (items.length === 1 && items[0].title.length === 0);

export const getDefaultItem = (id: number): Item => ({
    id,
    title: ``,
    duration: 30,
    lock: null,
});

export const roundMinutes = (minutes: number): number =>
    Math.ceil(minutes / DURATION_STEP) * DURATION_STEP;
